<template>
  <div class="bg-light">
    <b-row no-gutters align-h="between">
      <div class="text-center pt-1 pl-3" v-if="scoreInfo.showTreeSelect">
        <b-link  class="local-link clickable" @click="toggleShowHelpModal(true)" >
          {{ $t('Webportal.CX.Score.HelpButton') }}
          <font-awesome-icon :icon="['far', 'question-circle']"/>
        </b-link>
      </div>

      <b-form-radio-group 
        buttons button-variant="outline-secondary" size="sm"
        v-model="mode"
        v-if="scoreInfo.showTreeSelect && scoreInfo.showSelector">
        <b-form-radio :value="1">
          <span>
            <font-awesome-icon :icon="['fas', 'chart-line']" />
          </span>
        </b-form-radio>
        <b-form-radio :value="2">
          <span>
            <font-awesome-icon :icon="['fas', 'bars']" />
          </span>
        </b-form-radio>
      </b-form-radio-group>
    </b-row>

    <b-row no-gutters>
      <b-col>
        <div v-if="mode === 1" class="p-3" style="font-weight: 600">
          <DxChart  class="cx-overall-score-chart-control local-chart"
                    id="chart"
                    :size="size"
                    :data-source="Scores">
            <DxSeries argument-field="Date"
                      value-field="CxScore"
                      name="CXScore"
                      type="line"
                      :color="getColor(0)" />
            <!-- <DxSeries argument-field="Date"
                      value-field="ExplorationScore"
                      name="ExplorationScore"
                      type="line"
                      :color="getColor(1)" /> -->
            <DxTooltip  :enabled="true"
                        :customize-tooltip="customizeTooltip" />
            
            <DxValueAxis :min="valueAxis.min" :max="valueAxis.max" />

            <DxLegend   verticalAlignment="bottom" 
                        horizontalAlignment="center"
                        :visible="scoreInfo.showTreeSelect && scoreInfo.showSelector" />
          </DxChart>
        </div>
        <div v-else class="px-3">
          {{$t('Webportal.CX.OverallScore')}}
          <ProgressBar
            :ColorRange="ColorRange"
            :Score="currentScores.CxScore"
            class="mb-3"
          />
          {{ explorationScoreText() }}
          <ProgressBar
            :ColorRange="ColorRange"
            :Score="currentScores.ExplorationScore"
            class="mb-3"
          />
        </div>
      </b-col>
    </b-row>

    <b-modal  v-model="showHelpModal"
              :title="$t('Webportal.CX.Scores.ScoreCalculationHintLabel')"
              no-stacking
              hide-footer 
              size="md"
              centered>
      <p class="my-4">{{ $t("Webportal.CX.Scores.CXScoreHelpModalText1") }}</p>
      <p class="my-4">{{ $t("Webportal.CX.Scores.CXScoreHelpModalText2") }}</p>
    </b-modal>
  </div>
</template>

<script>

import ProgressBar from "@/components/Shared/ProgressBar";
import EventBus from "@/services/EventBus";
import { DxChart, DxSeries, DxTooltip, DxCommonSeriesSettings, DxLabel , DxCrosshair, DxLegend, DxValueAxis } from 'devextreme-vue/chart';

export default {
  name: "Scores",

  components: {
    ProgressBar,
    DxChart, DxCommonSeriesSettings, DxCrosshair, DxLabel, DxLegend, DxSeries, DxTooltip, DxValueAxis
  },

  props: {
    ColorRange:       { type: Array },
    scoreInfo:        { type: Object, default: () => undefined },
    Scores:           { type: Array, default: () => [] },
    theme:            { type: String, default: () => 'light' },
  },

  data() {
    return {
      mode: 1,
      size: {
        height: 210,
        width: 350
      },
      seriesData: [
        {
          color: 'black',
          colorDark: 'white'
        }, 
        {
          color: 'darkgrey',
          colorDark: 'cornflowerblue'
        }
      ],
      valueAxis: {
        min: 0,
        max: 100
      },
      showHelpModal: false
    }
  },

  created() {
    this.setScoreDates();
  },

  mounted() {
    EventBus.$emit('ScoresVueMounted');
  },

  watch: {
    Scores: {
      immediate: true,
      handler() {
        this.setScoreDates();
      }
    }
  },
  
  computed: {
    isLoading() {
      if(this.Scores.length == 0 && !this.currentScores) {
        return true;
      }
      return false;
    },
    currentScores() {
      var currentDate = new Date(Date.now());
      var scores = this.Scores.find( x => x.Year == currentDate.getFullYear() && x.Month == (currentDate.getMonth() + 1));
      return scores;
    }
  },

  methods: {
    toggleShowHelpModal(force) {
      this.showHelpModal = force !== undefined ? force : !this.showHelpModal;
    },

    getColor(index) {
      return this.theme == 'light' ? this.seriesData[index].color : this.seriesData[index].colorDark;
    },
    setScoreDates() {
      this.Scores.forEach(item => {
        item.Date = new Date(item.Year, (item.Month - 1), 1, 0, 0, 0, 0)
      });
    },
    customizeTooltip(arg) {
      var dateString = arg.argument.toLocaleString('default', {month: 'short', year: 'numeric'});
      return {
        text: `${dateString}\n${arg.value}`
      };
    },
    explorationScoreText() {
      return this.$t('Webportal.Dashboard.Exploration') + ' ' + this.$t('Webportal.Cx.Dashboard.Score');
    }
  }
};
</script>

<style lang="scss" scoped>
.local-chart {
  margin: auto;
  width: 100%;
  max-height: 15rem;
}

.local-link {
  color: var(--color-primary);
}
</style>